<template>
  <div id="app" :class="$store.getters['user/theme']">
    <div v-if="!underMaintenance">
        <template v-if="$store.getters['user/isLoaded'] && $store.getters['nutrients/isLoaded']">
        {{ setLanguage() }}
      </template>

      <template v-else>
        <div class="loading">
          <MainLoader/>
          <h2>{{$ml.get('Loading...')}}</h2>
        </div>
      </template>

      <Adverts v-if="$store.getters['user/isLoaded'] && $store.getters['nutrients/isLoaded']" />

      <transition name="cool">
        <router-view id="content"/>
      </transition>

      <AppFooter/>

      <transition name="modal-fade-scale">
        <Alert v-if="$store.getters['modals/alert/isOpened']"/>
      </transition>

      <notifications group="notices" position="bottom right" />
    </div>
    <ServerUnderMaintenance v-else/>
    


    <!-- <div class="maintance">
      <h2>
        Dear user, we are sorry but the software is under maintenance. <br>
        Try to login in again in a couple of hours. We apologise for the inconvenience
      </h2>
    </div> -->
  </div>

</template>

<script>
import Alert from '@/components/common/modals/Alert'
import Adverts from '@/components/common/modals/Adverts'
import MainLoader from '@/components/common/MainLoader';
import AppFooter from '@/components/common/AppFooter';
import ServerUnderMaintenance from '@/components/ui/ServerUnderMaintenance';

export default {
  data() {
    return {
      blackTheme: false,
      underMaintenance: true
    }
  },
  updated() {
    let userData = this.$store.getters['user/data']
    let currentPath = this.$router.currentRoute.path

    if(
      currentPath != '/' && 
      currentPath != '/dashboard/account' && 
      !currentPath.includes('auth') && 
      !currentPath.includes('quick') && 
      !currentPath.includes('license-terms') &&
      !currentPath.includes('privacy-policy') &&
      (userData.state == null || userData.city == null || userData.zip == null || userData.address == null)) {
      this.$router.push('/dashboard/account')
      this.$store.commit('modals/alert/open', {text: 'Please, enter your location data'})
    }

    
  },
  created() {
    this.$listenNote('plan/subs/update', data => {
      this.$store.commit('user/saveSubsStatus', data.status);
    });

    this.$listenNote('user/update', data => {
      this.$store.dispatch('user/updateData');
      this.$store.dispatch('user/availableReports');
    });

    window.location.replace('https://front.i-plantnutrition.com')
  },
  methods: {

    setLanguage () {
      if (this.$store.getters['user/data']) {
        var lang = this.$store.getters['user/data'].language;
        if (lang) {
          this.$ml.change(lang);
        } else {
          this.$ml.change('en');
        }
      }
      return '';
    }
  },
  components: {
    Alert,
    Adverts,
    MainLoader,
    AppFooter,
    ServerUnderMaintenance
  }
}
</script>

<style lang="scss" scoped>

#content {
  &.cool {
    &-enter {
      opacity: 0;
    }
    &-enter-to {
      opacity: 1;
    }
    &-leave-active {
      display: none;
    }
    &-enter-active {
      transition: opacity 0.5s ease;
    }
  }
}

#app {
  flex-wrap: wrap;
  &.dark {
    filter: invert(0.8);
  }
  &.cursed {
    animation: cursed 10s infinite linear;
  }
  @keyframes cursed {
    from { filter: hue-rotate(0deg); }
    to { filter: hue-rotate(1000deg); }
  }
}
.privacy {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 100%;
  background-color: #fff;
  border-top: 1px #E4E5E6 solid;
  font-size: 12px;
  .devider {
    padding-right: 8px;
    padding-left: 8px;
  }
}

.loading {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h2 {
    margin-top: 70px;
  }
}

.maintance {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.5;
  text-align: center;
  h2 {
    margin-top: 70px;
  }
}

</style>
